import React, { useEffect } from "react";

import { useState,useContext } from "react";
import { Typography } from "@mui/material";
import { useUrlContext } from '../context/urlContext';

import { errorContext } from "../Components/ErrorDisplay";
import { useConfirm } from "../Components/ConfirmDialog";
import ParentComponent from "../Components/ParentForTableAndFormComponent";
import axios from "axios";
import PrinterLocationForm from "../Forms/PrinterLocationForm";
import { useAuth } from '../context/authContext';

export default function PrinterLocation(props) {
    const {user} = useAuth();
    const { UrlHelperObj } = useUrlContext();
    const confirm = useConfirm();
    const [columnInfo, setColumnInfo] = useState([
        {  title: 'Mac Id',dbname:'mac' },
        {title:"Time Zone",dbname:"timezone"},
        
    ]);
    const[selectedLocation,setSelectedLocation] = useState(null);
    const[printerLocationRecords,setPrinterLocationRecords]=useState([]);
    const[isAddDisabled,setIsAddDisabled] = useState(false);
    const {handleError} = useContext(errorContext);

    useEffect(()=>{setSelectedLocation(props.LocationRow)
    },[props.LocationRow]);

    useEffect(()=>{getPrinterLocationRecords()},[selectedLocation]);

    useEffect(()=>{
        if(printerLocationRecords.length >= 1)
            setIsAddDisabled(true);
        else
            setIsAddDisabled(false);

    },[printerLocationRecords]);

    async function getPrinterLocationRecords()
    {
        if(selectedLocation === null)
            return;
        console.log("user issuer id:"+user.issuerId);
        console.log("Selected Location id:"+JSON.stringify(selectedLocation));
        await axios.get(UrlHelperObj.printerlocationUrl_GET(selectedLocation.id,user.issuerId))
        .then(response => {console.log("Response data:"+JSON.stringify(response.data)); return response.data;})
        .then(results => {console.log("Printer Location Records: "+JSON.stringify(results));setPrinterLocationRecords(results)})
        .catch(err => handleError(err));
    }
    async function deletePrinterLocationRecord(record)
    {
        const shouldDelete = await confirm({ title: 'Delete scanning device', message: 'Delete this scanning device?', confirmText: 'Delete' });
        if(!shouldDelete)
            return;

        try {
            console.log("Deleting record: "+JSON.stringify(record));
            await axios.delete(UrlHelperObj.printerlocationUrlById(record));
            console.log("delete of Printer Location "+record+" successful");

            if(props.setSelectedRow)
                props.setSelectedRow(null);

            if(props.onDeleteSuccess)
                props.onDeleteSuccess(record);

            await new Promise(resolve => setTimeout(resolve, 500));

            if(props.LocationRow === null || props.LocationRow === undefined)
            {
                console.log("LocationRow is null, clearing records");
                setPrinterLocationRecords([]);
                return;
            }

            console.log("Refetching for location: "+JSON.stringify(props.LocationRow));
            const response = await axios.get(UrlHelperObj.printerlocationUrl_GET(props.LocationRow.id,user.issuerId));
            console.log("Refetch response: "+JSON.stringify(response.data));
            setPrinterLocationRecords(response.data);
        } catch (err) {
            console.error("Delete error:", err);
            handleError(err);
            await getPrinterLocationRecords();
        }
    }

    async function editPrinterLocationRecord(record)
    {
        const timezoneValue = record.timezone || record.timeZone || '';
        const accessMap = { 'None': 0, 'Auto': 1, 'Manual': 2 };
        const data = {
            id:record.id,
            mac_id:record.mac_id,
            location_id:record.location_id,
            device_type:record.device_type,
            timezone:timezoneValue,
            access: record.access ?? accessMap[props.mode] ?? 0
        }
        
        console.log("EDIT Printer location - sending to API:", JSON.stringify(data));
        
        await axios.put(UrlHelperObj.printerlocationUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Edit of printer location "+record+" successful"))
        .catch(err => handleError(err));
        getPrinterLocationRecords();
    }
    /*function handleError(err)
    {
        setLoading(false);
        if(err.response)
        {
            console.log(err.response);
            setErrorMessage(err.response.data.message);
        }
        else if(err.request)
        {
            console.log(err.request);
        }
    }*/
    async function addPrinterLocationRecord(record)
    {
        const timezoneValue = record.timezone || record.timeZone || '';
        const data = {
            id:0,
            issuer_id:user.issuerId,
            mac_id:record.mac_id,
            location_id:record.location_id,
            device_type:record.device_type,
            timezone:timezoneValue
        }
        
        console.log("ADD Printer location - sending to API:", JSON.stringify(data));
        await axios.post(UrlHelperObj.printerlocationUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Add of printer "+record+" successful"))
        .catch(err => handleError(err));
        getPrinterLocationRecords();
    }
    useEffect(() =>{
        //setTableFlag(true);
        getPrinterLocationRecords();
    },[]);

    function handleFormSubmit(data,isAddOperation,isCancelOperation)
    {
        props.setFormShown(false);
        if(isCancelOperation === true)
        {
            console.log("Cancelled operation");
            return 0;
        }
        if(isAddOperation === true)
            addPrinterLocationRecord(data);
        else
            editPrinterLocationRecord(data);
    }
/*    
            {printerLocationRecords.length === 0 && (
                <Typography variant="h6" style={{textAlign: 'center', marginTop: '20px', color: '#666'}}>
                    No records found
                </Typography>
            )}
*/    
    return(
    
        <>
            {isAddDisabled && (
                <Typography style={{ color: '#b26a00', marginBottom: 8, textAlign: 'left' }}>
                    Only one scanning device is allowed per location. Delete the existing one to add another.
                </Typography>
            )}
            <ParentComponent
            data={printerLocationRecords}
            columns={columnInfo}
            form={PrinterLocationForm}
            formTitle={"Scanning Device"}
            handleFormSubmitFunc={handleFormSubmit}
            setFormShownFlag={props.setFormShown}
            alreadySelectedOwnRow={props.alreadySelectedOwnRow}
            deleteFunc={deletePrinterLocationRecord}
            setSelectedRow={props.setSelectedRow}
            selectedLocationRow={props.LocationRow}
            isAddDisabled={isAddDisabled}
            mode={props.mode}
            />
        </>
    );
            
}

